import { addDays, Interval, startOfDay, toDate } from 'date-fns';
import { ApolloError, TypedDocumentNode, useSuspenseQuery } from '@apollo/client';
import gql from 'graphql-tag';
import { MarketLocationTimeSeries, MarketLocationTimeSeriesType } from 'generated/graphql';

const MarketLocationTimeSeriesQuery: TypedDocumentNode = gql`
  query MarketLocationTimeSeries(
    $marketLocationNumbers: [ID!]!
    $marketLocationTimeSeriesTypes: [MarketLocationTimeSeriesType!]!
    $interval: IntervalInput!
  ) {
    marketLocationTimeSeries(
      marketLocationNumbers: $marketLocationNumbers
      marketLocationTimeSeriesTypes: $marketLocationTimeSeriesTypes
      interval: $interval
    ) {
      marketLocationNumber
      marketLocationTimeSeriesType
      datapoints {
        timestamp
        value
      }
    }
  }
`;

export function useMarketLocationTimeSeries(
  marketLocationNumbers: readonly string[],
  marketLocationTimeSeriesTypes: MarketLocationTimeSeriesType[],
  interval: Interval,
): [MarketLocationTimeSeries[] | undefined, ApolloError | undefined] {
  const { data, error } = useSuspenseQuery(MarketLocationTimeSeriesQuery, {
    variables: {
      marketLocationNumbers,
      marketLocationTimeSeriesTypes,
      interval: {
        start: toDate(interval.start),
        end: toDate(startOfDay(addDays(interval.end, 1))),
      },
    },
    errorPolicy: 'all',
  });

  return [data?.marketLocationTimeSeries, error];
}
